var React = require('react');

function IconCircleInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C3.55271368e-15,5.372583 5.372583,-3.55271368e-15 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z M13,11.75 L13,16.25 C13,16.6642136 12.5522847,17 12,17 C11.4477153,17 11,16.6642136 11,16.25 L11,11.75 C11,11.3357865 11.4477153,11 12,11 C12.5522847,11 13,11.3357865 13,11.75 Z M13,8 C13,8.5522847 12.5522847,9 12,9 C11.4477153,9 11,8.5522847 11,8 C11,7.4477153 11.4477153,7 12,7 C12.5522847,7 13,7.4477153 13,8 Z","fill":"currentColor"}));
}

IconCircleInfo.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = IconCircleInfo;

IconCircleInfo.default = IconCircleInfo;
